<template>
  <div class="auth-shell">
    <div class="auth-card surface-elevated">
      <div class="brand-wrap">
        <img class="brand-logo" src="@/assets/images/logo.png" alt="BestPhone" />
      </div>

      <div class="stack-sm auth-header">
        <h1 class="display-title">{{ get_word('create_password_title') || 'יצירת סיסמה' }}</h1>
        <p class="muted">{{ get_word('create_password_subtitle') || 'עוד רגע מסיימים בוחרים סיסמה חדשה וממשיכים לאזור האישי.' }}</p>
      </div>

      <form class="auth-form stack-md" @submit.prevent="submitPassword">
        <div class="field">
          <label class="form-label">{{ get_word('new_password') || 'סיסמה חדשה' }}</label>
          <div class="password-field">
            <input
              v-model="form.password"
              :type="showPassword ? 'text' : 'password'"
              class="input-control"
              :placeholder="get_word('new_password_placeholder') || 'לפחות 6 תווים'"
              required
            />
            <button type="button" class="password-toggle" @click="showPassword = !showPassword">
              {{ showPassword ? (get_word('hide') || 'הסתר') : (get_word('show') || 'הצג') }}
            </button>
          </div>
          <small v-if="errors.password" class="help-error">{{ errors.password }}</small>
        </div>

        <div class="field">
          <label class="form-label">{{ get_word('confirm_password') || 'אימות סיסמה' }}</label>
          <div class="password-field">
            <input
              v-model="form.password_confirm"
              :type="showConfirmPassword ? 'text' : 'password'"
              class="input-control"
              :placeholder="get_word('confirm_password_placeholder') || 'הקלידו שוב את הסיסמה'"
              required
            />
            <button type="button" class="password-toggle" @click="showConfirmPassword = !showConfirmPassword">
              {{ showConfirmPassword ? (get_word('hide') || 'הסתר') : (get_word('show') || 'הצג') }}
            </button>
          </div>
          <small v-if="errors.password_confirm" class="help-error">{{ errors.password_confirm }}</small>
        </div>

        <button type="submit" :disabled="loading" class="btn btn-primary auth-submit">
          <span v-if="!loading">{{ get_word('save_password') || 'שמירת סיסמה והמשך' }}</span>
          <span v-else>{{ get_word('loading') || 'טוען...' }}</span>
        </button>

        <div v-if="generalError" class="error-inline">{{ generalError }}</div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CreatePassword',
  data() {
    return {
      form: {
        password: '',
        password_confirm: ''
      },
      loading: false,
      showPassword: false,
      showConfirmPassword: false,
      errors: {},
      generalError: ''
    }
  },
  mounted() {
    if (!localStorage.getItem('user_token')) { this.$router.push('/login'); return }
  },
  methods: {
    submitPassword() {
      this.errors = {}
      this.generalError = ''

      if (!this.form.password) {
        this.errors.password = this.get_word('password_required') || 'יש להזין סיסמה חדשה'
        return
      }

      if (this.form.password.length < 6) {
        this.errors.password = this.get_word('password_too_short') || 'הסיסמה חייבת להכיל לפחות 6 תווים'
        return
      }

      if (!this.form.password_confirm) {
        this.errors.password_confirm = this.get_word('confirm_password_required') || 'יש להזין אימות סיסמה'
        return
      }

      if (this.form.password !== this.form.password_confirm) {
        this.errors.password_confirm = this.get_word('passwords_not_match') || 'הסיסמאות אינן תואמות'
        return
      }

      this.loading = true
      this.api({
        action: 'complete_password_setup',
        data: {
          password: this.form.password,
          password_confirm: this.form.password_confirm
        },
        method: 'post'
      }, (response) => {
        if (response && response.data && response.data.success) {
          localStorage.removeItem('require_password_setup')
          this.activateSuccess(this.get_word('password_saved_success') || 'נהדר! הסיסמה נשמרה בהצלחה')
          setTimeout(() => this.$router.push('/'), 500)
          return
        }

        const err = response && response.data && response.data.error
        if (err === 'password_too_short') {
          this.generalError = this.get_word('password_too_short') || 'הסיסמה חייבת להכיל לפחות 6 תווים'
        } else if (err === 'password_mismatch') {
          this.generalError = this.get_word('passwords_not_match') || 'הסיסמאות אינן תואמות'
        } else if (err === 'password_already_exists') {
          localStorage.removeItem('require_password_setup')
          this.$router.push('/')
        } else {
          this.generalError = this.get_word('password_save_failed') || 'שמירת הסיסמה לא הצליחה כרגע, נסו שוב'
        }

        this.loading = false
      }, () => {
        this.generalError = this.get_word('password_save_failed') || 'שמירת הסיסמה לא הצליחה כרגע, נסו שוב'
        this.loading = false
      })
    }
  }
}
</script>


